import * as ReactRouterDom from 'react-router-dom';

function Navbar() {
  const navClass = ({ isActive }) =>
    `rounded-full px-4 py-2 text-sm font-semibold transition ${
      isActive ? 'bg-brand-mist text-brand-deep' : 'text-brand-text/80 hover:bg-white hover:text-brand-deep'
    }`;

  return (
    <header className="sticky top-0 z-30 border-b border-brand-petal/70 bg-brand-bg/90 backdrop-blur">
      <nav className="mx-auto flex w-full max-w-7xl items-center justify-between px-6 py-4 sm:px-8">
        <ReactRouterDom.NavLink to="/" className="font-display text-3xl font-semibold leading-none text-brand-deep">
          Best Brows & Beauty
        </ReactRouterDom.NavLink>

        <div className="hidden items-center gap-2 sm:flex">
          <ReactRouterDom.NavLink to="/" className={navClass} end>
            Home
          </ReactRouterDom.NavLink>
          <ReactRouterDom.NavLink to="/about" className={navClass}>
            About
          </ReactRouterDom.NavLink>
          <ReactRouterDom.NavLink to="/services" className={navClass}>
            Services
          </ReactRouterDom.NavLink>
        </div>

        <a
          href="tel:+17175257477"
          className="rounded-full border border-brand-primary/35 bg-white px-4 py-2 text-sm font-semibold text-brand-deep transition hover:bg-brand-mist"
        >
          (717) 525-7477
        </a>
      </nav>
    </header>
  );
}

export default Navbar;